import { API_URL } from "../apiConfig";

/** Same field order as legacy Client Mgmt / FolderView. */
export function getClientAvatarUrl(client) {
  if (!client || typeof client !== "object") return "";
  return (
    client.avatarUrl ||
    client.photoUrl ||
    client.imageUrl ||
    client.profileImage ||
    client.profilePic ||
    client.pictureUrl ||
    ""
  );
}

export function getClientDisplayName(client) {
  const first = String(client?.firstName || "").trim();
  const last = String(client?.lastName || "").trim();
  const full = `${first} ${last}`.trim();
  return (
    full ||
    String(client?.name || client?.fullName || client?.clientName || "").trim() ||
    "Unknown Client"
  );
}

export function getClientInitial(client) {
  const name = getClientDisplayName(client);
  const ch = (name || "").trim().charAt(0);
  return ch ? ch.toUpperCase() : "?";
}

/** Resolve relative or API paths; leave data: and https: unchanged. */
export function resolveClientAvatarUrl(client, apiBase = API_URL) {
  const raw = String(getClientAvatarUrl(client) || "").trim();
  if (!raw) return "";
  if (
    raw.startsWith("data:") ||
    raw.startsWith("http://") ||
    raw.startsWith("https://") ||
    raw.startsWith("blob:")
  ) {
    return raw;
  }
  if (raw.startsWith("/")) {
    const base = String(apiBase || "").replace(/\/api\/?$/, "");
    return `${base}${raw}`;
  }
  return raw;
}

export function normalizeClientFolderId(client) {
  return String(client?.folderId?._id || client?.folderId || "").trim();
}
